<template>
    <section class="px-4 py-8 mx-auto max-w-6xl lg:py-16 xl:px-0">
        <h3 class="text-black text-2xl sm:text-3xl md:text-4xl font-ww-bold xl:!leading-none xl:text-42 text-center" v-html="mainHeading">
        </h3>
        <div class="mt-8 lg:mt-16">
            <div class="grid grid-cols-12 border-2 rounded-lg border-[#E48414]" :style="{ background: containerBackground }">
                <div class="col-span-12 p-8 md:col-span-6 lg:p-10">
                    <div>
                        <nuxt-img :src="productImage.src" :alt="productImage.alt"
                            class="object-cover mx-auto w-full h-full" loading="lazy" 
                            :width="productImage.width" :height="productImage.height" 
                            :sizes="productImage.sizes" :style="{ maxWidth: productImage.maxWidth }" />
                    </div>
                    <div class="flex gap-x-3 justify-center items-center mt-8">
                        <nuxt-img :src="safeImage.src" :width="safeImage.width" :height="safeImage.height" 
                            :alt="safeImage.alt" class="" loading="lazy" />
                        <a :href="bbbLink.href" class="p-0.5 bg-white rounded-lg border border-black h-fit" 
                            target="_blank" rel="nofollow">
                            <nuxt-img loading="lazy" :width="bbbLink.width" :height="bbbLink.height"
                                :src="bbbLink.src" style="border: 0;" :alt="bbbLink.alt" />
                        </a>
                    </div>
                    <div class="flex justify-start items-center mt-10">
                        <div class="flex gap-x-1 items-center mr-2">
                            <svg v-for="star in 5" :key="star" width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="w-4 h-4">
                                <path
                                    d="M6.36189 5.1572C6.36189 5.1572 3.20189 5.5072 1.09389 5.7412C0.90389 5.7642 0.73589 5.8912 0.67289 6.0842C0.60989 6.2772 0.67289 6.4782 0.81289 6.6052C2.37889 8.0342 4.73189 10.1742 4.73189 10.1742C4.72989 10.1742 4.08589 13.2872 3.65789 15.3642C3.62189 15.5522 3.68989 15.7512 3.85389 15.8702C4.01689 15.9892 4.22689 15.9912 4.39189 15.8982C6.23589 14.8502 8.99789 13.2742 8.99789 13.2742C8.99789 13.2742 11.7609 14.8502 13.6019 15.8992C13.7699 15.9912 13.9799 15.9892 14.1429 15.8702C14.3069 15.7512 14.3749 15.5522 14.3379 15.3652C13.9099 13.2872 13.2669 10.1742 13.2669 10.1742C13.2669 10.1742 15.6199 8.0342 17.1859 6.6082C17.3259 6.4772 17.3879 6.2762 17.3259 6.0842C17.2639 5.8922 17.0959 5.7652 16.9059 5.7432C14.7979 5.5072 11.6369 5.1572 11.6369 5.1572C11.6369 5.1572 10.3269 2.2592 9.45389 0.327203C9.37189 0.154203 9.19989 0.0332031 8.99789 0.0332031C8.79589 0.0332031 8.62289 0.155203 8.54489 0.327203C7.67089 2.2592 6.36189 5.1572 6.36189 5.1572Z"
                                    :fill="star <= Math.round(currentRating?.avg_rating || 0) ? '#F1574B' : '#E5E7EB'" />
                            </svg>
                        </div>
                        <span class="text-[#3B3B3B] font-ww-regular text-base">
                            <strong>{{ currentRating?.avg_rating }}/5</strong> {{ fromText }} <strong>{{
                                currentRating?.reviews_count }}</strong> {{ reviewsText }}
                        </span>
                    </div>
                    <div class="text-base italic !leading-5 md:text-17 font-ww-regular mt-4" v-html="testimonialQuote">
                    </div>
                </div>
                <div class="col-span-12 md:col-span-6">
                    <div class="px-8 py-8 rounded-tr-lg lg:px-12" :style="{ background: kitBackground }">
                        <div>
                            <h3 class="text-2xl text-center sm:text-3xl md:text-32 font-ww-bold md:text-left" v-html="kitTitle">
                            </h3>
                            <ul class="mt-6 space-y-3 text-base md:text-lg">
                                <li v-for="(item, index) in kitItems" :key="index" class="flex justify-between items-center w-full text-black text-balance">
                                    <span class="flex gap-x-2 items-center text-sm whitespace-nowrap font-ww-bold sm:text-base lg:text-lg !leading-4" v-html="item.name">
                                    </span>
                                    <div class="relative -bottom-2 flex-grow mx-2 border-b border-black"></div>
                                    <span class="text-sm whitespace-nowrap lg:text-lg font-ww-regular sm:text-base">
                                        value: {{ item.value }}</span>
                                </li>
                            </ul>
                            <div class="mt-7 w-full h-[1px] bg-black"></div>
                            <div class="mt-1 w-full h-[1px] bg-black"></div>
                            <div class="mt-6 text-base text-right line-through md:text-lg" v-html="totalValueText">
                            </div>
                            <div class="mt-2 text-xl text-right text-black lg:text-2xl font-ww-bold" v-html="finalPrice">
                            </div>
                            <div class="mt-2 text-base text-right md:text-lg" v-html="servingText">
                            </div>
                        </div>
                    </div>
                    <div class="px-10 py-6 bg-black rounded-br-lg">
                        <div class="text-lg leading-5 text-center text-white md:text-xl font-ww-bold" v-html="orderText">
                        </div>
                        <button  @click="addToCart"
                            class="inline-flex justify-center items-center px-8 py-4 mt-5 w-full text-lg font-bold text-white rounded-full transition-colors duration-200 font-ww-medium btn-red hover:bg-red-600">
                            {{ buttonText }}
                        </button>
                        <div>
                            <nuxt-img :src="paymentImage.src" :alt="paymentImage.alt"
                                class="object-cover mx-auto mt-4" loading="lazy" 
                                :sizes="paymentImage.sizes" :width="paymentImage.width" :height="paymentImage.height" />
                        </div>
                        <div class="flex gap-x-2 justify-center items-center mt-4">
                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0.105469V1.55039H13.7267V12.3873H9.27909C8.95737 11.1455 7.83981 10.2199 6.50213 10.2199C5.16446 10.2199 4.0469 11.1455 3.72518 12.3873H2.88984V8.77498H1.44492V13.8322H3.72518C4.0469 15.0739 5.16446 15.9996 6.50213 15.9996C7.83981 15.9996 8.95737 15.0739 9.27909 13.8322H15.2845C15.6062 15.0739 16.7238 15.9996 18.0615 15.9996C19.3992 15.9996 20.5167 15.0739 20.8384 13.8322H23.1187V7.93964L23.0735 7.82675L21.6286 3.492L21.4706 2.99531H15.1716V0.105469H0ZM0.722459 2.99531V4.44022H7.22459V2.99531H0.722459ZM15.1716 4.44022H20.4321L21.6738 8.14283V12.3873H20.8384C20.5167 11.1455 19.3992 10.2199 18.0615 10.2199C16.7238 10.2199 15.6062 11.1455 15.2845 12.3873H15.1716V4.44022ZM1.44492 5.88514V7.33006H5.77967V5.88514H1.44492ZM6.50213 11.6648C7.30926 11.6648 7.94705 12.3026 7.94705 13.1097C7.94705 13.9169 7.30926 14.5547 6.50213 14.5547C5.69501 14.5547 5.05721 13.9169 5.05721 13.1097C5.05721 12.3026 5.69501 11.6648 6.50213 11.6648ZM18.0615 11.6648C18.8686 11.6648 19.5064 12.3026 19.5064 13.1097C19.5064 13.9169 18.8686 14.5547 18.0615 14.5547C17.2544 14.5547 16.6166 13.9169 16.6166 13.1097C16.6166 12.3026 17.2544 11.6648 18.0615 11.6648Z" fill="white"/>
                            </svg>
                            <span class="text-base text-white md:text-lg font-ww-regular" v-html="shippingText">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const products = [
  {id:'42133448425532', qty: 1, price: 59.00 , title: 'Mindflow', selling_plan: 1447559228},
  {id:'42133501018172', qty: 1, price: 0.00 , title: 'Copper Lifeboost Coffee Scoops', selling_plan: null},
  {id:'42120155168828', qty: 1, price: 0.00 , title: 'The Ultimate Toxin-Free Living Guide - Digital eBook', selling_plan: null},
  {id:'39411358498876', qty: 1, price: 0.00 , title: '100 Espresso Recipes From Around The World - Digital Recipe eBook', selling_plan: null},
];

const cart = useCart();

function addToCart() {
   products.forEach(product => {
    cart.add(product);
  });
  //Discount Codes!
  cart.checkout("", true)
}


const props = defineProps({
    mainHeading: {
        type: String,
        default: 'Hurry! Order Now Because We Only Have a Limited Number of Bags of Mindflow Left Due to the Limited Availability of Its Patented Ingredients.'
    },
    containerBackground: {
        type: String,
        default: '#FBF0E5'
    },
    productImage: {
        type: Object,
        default: () => ({
            src: '/assets/images/mindflow-3x-cart.png',
            alt: 'Mindflow',
            width: 492,
            height: 399,
            sizes: 'xs:215px sm:325px md:492px lg:422px xl:478px',
            maxWidth: '492px'
        })
    },
    safeImage: {
        type: Object,
        default: () => ({
            src: '/assets/images/safe-brilliantly.png',
            width: 87,
            height: 93,
            alt: 'safe'
        })
    },
    bbbLink: {
        type: Object,
        default: () => ({
            href: 'https://www.bbb.org/us/in/carmel/profile/coffee-and-tea/lifeboost-coffee-0382-90017189/#sealclick',
            src: 'https://seal-indy.bbb.org/seals/blue-seal-200-65-bbb-90017189.png',
            width: 200,
            height: 65,
            alt: 'Lifeboost Coffee BBB Business Review'
        })
    },
    fromText: {
        type: String,
        default: 'from'
    },
    reviewsText: {
        type: String,
        default: 'reviews'
    },
    testimonialQuote: {
        type: String,
        default: '"Mindflow gave me back control of my workday. I\'m focused, calm, and incredibly productive without the caffeine crash I used to dread." — Jonas Becker, Berlin, Germany'
    },
    kitBackground: {
        type: String,
        default: '#C4E538'
    },
    kitTitle: {
        type: String,
        default: 'Mindflow Morning Coffee Upgrade Kit'
    },
    kitItems: {
        type: Array,
        default: () => [
            { name: 'Mindflow (3 bags)', value: '$119.97' },
            { name: 'Metal Scooper', value: '$25' },
            { name: 'Habit-Tracking App', value: '$35' },
            { name: 'Coffee Recipe Book', value: '$30' },
            { name: 'Everlo remineralization <br>coffee upgrade drops', value: '$40' }
        ]
    },
    totalValueText: {
        type: String,
        default: 'Total value: $249'
    },
    finalPrice: {
        type: String,
        default: '$24.99/bag!'
    },
    servingText: {
        type: String,
        default: '(Less than $1.00 per serving!)'
    },
    orderText: {
        type: String,
        default: 'One-time order. No recurring charges.'
    },
    buttonText: {
        type: String,
        default: 'Add to Cart'
    },
    paymentImage: {
        type: Object,
        default: () => ({
            src: '/assets/images/payment-methods.png',
            alt: 'payment methods',
            sizes: 'xs:199px sm:404px md:404px lg:404px xl:404px',
            width: 404,
            height: 33
        })
    },
    shippingText: {
        type: String,
        default: 'FREE Shipping'
    },
    productId: {
        type: String,
        default: "8615875870780"
    },
    handle: {
        type: String,
        default: "single-origin-medium-roast-decaf-coffee"
    }
})

// Initialize rating functionality
const { fetchRatingReview } = useReviews()
const currentRating = ref(null)

// Fetch rating on component mount
onMounted(async () => {

    currentRating.value = await fetchRatingReview(props.productId, props.handle)
})

// Watch for changes in product ID or handle
watch(
    [() => props.productId, () => props.handle],
    async ([newProductId, newHandle]) => {
        currentRating.value = await fetchRatingReview(newProductId, newHandle)
    }
)

defineBuilderComponent({
    friendlyName: 'Product Offer',
    canHaveChildren: false,
    inputs: [
        {
            name: 'mainHeading',
            type: 'richText',
            defaultValue: 'Hurry! Order Now Because We Only Have a Limited Number of Bags of Mindflow Left Due to the Limited Availability of Its Patented Ingredients.'
        },
        {
            name: 'containerBackground',
            type: 'color',
            defaultValue: '#FBF0E5'
        },
        {
            name: 'productImage',
            type: 'object',
            subFields: [
                { name: 'src', type: 'file' },
                { name: 'alt', type: 'text' },
                { name: 'width', type: 'number' },
                { name: 'height', type: 'number' },
                { name: 'sizes', type: 'text' },
                { name: 'maxWidth', type: 'text' }
            ],
            defaultValue: {
                src: '/assets/images/mindflow-3x-cart.png',
                alt: 'Mindflow',
                width: 492,
                height: 399,
                sizes: 'xs:215px sm:325px md:492px lg:422px xl:478px',
                maxWidth: '492px'
            }
        },
        {
            name: 'testimonialQuote',
            type: 'richText',
            defaultValue: '"Mindflow gave me back control of my workday. I\'m focused, calm, and incredibly productive without the caffeine crash I used to dread." — Jonas Becker, Berlin, Germany'
        },
        {
            name: 'kitBackground',
            type: 'color',
            defaultValue: '#C4E538'
        },
        {
            name: 'kitTitle',
            type: 'richText',
            defaultValue: 'Mindflow Morning Coffee Upgrade Kit'
        },
        {
            name: 'kitItems',
            type: 'list',
            subFields: [
                { name: 'name', type: 'richText' },
                { name: 'value', type: 'text' }
            ],
            defaultValue: [
                { name: 'Mindflow (3 bags)', value: '$119.97' },
                { name: 'Metal Scooper', value: '$25' },
                { name: 'Habit-Tracking App', value: '$35' },
                { name: 'Coffee Recipe Book', value: '$30' },
                { name: 'Everlo remineralization <br>coffee upgrade drops', value: '$40' }
            ]
        },
        {
            name: 'totalValueText',
            type: 'richText',
            defaultValue: 'Total value: $249'
        },
        {
            name: 'finalPrice',
            type: 'richText',
            defaultValue: '$24.99/bag!'
        },
        {
            name: 'servingText',
            type: 'richText',
            defaultValue: '(Less than $1.00 per serving!)'
        },
        {
            name: 'orderText',
            type: 'richText',
            defaultValue: 'One-time order. No recurring charges.'
        },
        {
            name: 'buttonText',
            type: 'text',
            defaultValue: 'Add to Cart'
        },
        {
            name: 'shippingText',
            type: 'richText',
            defaultValue: 'FREE Shipping'
        },
        {
            name: 'productId',
            type: 'text',
            defaultValue: "8615875870780"
        },
        {
            name: 'handle',
            type: 'text',
            defaultValue: "single-origin-medium-roast-decaf-coffee"
        }
    ]
})
</script>